/**
 * Animated three-dot "AI is thinking…" bubble for the embed page's
 * chat panel. Renders during the LLM-wait gap (callState === 'thinking')
 * after a 200 ms grace period — mock-key fallback returns instantly
 * and we don't want a visible flash for those.
 *
 * Pure CSS animation (`@keyframes`) — zero JS overhead, three children
 * with staggered animation-delay produce the classic bouncing-dots
 * pattern (Slack/Discord/ChatGPT all use this).
 */
import { type ReactElement } from 'react';

export function ThinkingBubble(): ReactElement {
  return (
    <div className="nx-thinking-bubble" aria-label="AI is thinking">
      <span className="nx-thinking-dot" />
      <span className="nx-thinking-dot" />
      <span className="nx-thinking-dot" />
    </div>
  );
}
